module.exports = "./img/fe147ba4564cb40d0648e022f498f588.png";